export enum SyncStatusEnum {
	Error,
	Synced,
	InProgress,
	NotStarted
}
export interface SyncStatus {
	date?: string;
	status: SyncStatusEnum;
}
